import React from 'react';
import { StyledLink } from './StyledComponent';

export default function SupportLink(props: any) {
  const { text } = props;
  return <StyledLink to="/support">{text || 'Contact support'}</StyledLink>;
}
